import { Grid, InputBaseComponentProps, SxProps, TextField, TextFieldProps } from '@mui/material'
import React, { ReactNode } from 'react'


interface textfieldProps {
    stylingClassName?: string;
    sx?: SxProps;
    placeholder?: string;
    multiline?: boolean;
    rows?: number;
    disabled?: boolean;
    value?: string | number;
    onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    type?: string;
    size?: 'small' | 'medium';
    variant?: 'filled' | 'outlined' | 'standard';
    id?: string;
    fullWidth?: boolean;
    autoComplete?: string;
    maxRows?: number;
    children?: ReactNode;
    inputProps?: InputBaseComponentProps; // Corrected type for inputProps
    InputProps?: TextFieldProps['InputProps']; // Correct type for InputProps
    onKeyPress?: any;
    helperText?: any
    required?: boolean
    error?: boolean
}

const GlobalTextfield = (props: textfieldProps) => {
    return (
        <>
            <TextField
                sx={props.sx}
                size={props.size}
                value={props.value}
                className={props.stylingClassName}
                variant={props.variant}
                onChange={props.onChange}
                type={props.type}
                inputProps={props.inputProps}
                id={props.id}
                disabled={props.disabled}
                multiline={props.multiline}
                rows={props.rows}
                maxRows={props.maxRows}
                placeholder={props.placeholder}
                onBlur={props.onBlur}
                fullWidth={props.fullWidth}
                autoComplete={props.autoComplete}
                onKeyPress={props.onKeyPress}
                helperText={props.helperText}
                required={props.required}
                error={props.error}
                {...props}
            />
        </>
    )
}


export default GlobalTextfield